import { Dispatch, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { isEmpty } from 'lodash-es';
import { Action } from 'redux';

import { StockExchangeCodeType, SymbolAndStockExchangeCode } from '../../../lib/models/fundamental/types';
import { GWMarketDataSummaryBucket } from '../../../lib/models/gateway/types';
import { RootState } from '../../../lib/store';
import { getCompanyLogoAndName as getLogoAndName } from '../../../lib/store/fundamental';
import { FundamentalCall } from '../../../lib/store/fundamental/types';
import { chartSubscription } from '../../../lib/store/market-data/subscriptionHelpers';
import { isCallStatusPending } from '../../../lib/util/error-handling/StatusByCallHelpers';

import WatchListTable from './WatchListTable';

type Props = ReduxProps;

const PopularWatchList = (props: Props) => {
  const { popularStocks, companyLogoAndName, getCompanyLogoAndName } = props;

  const filteredStocks = popularStocks.map(({ popularity, symbolUniverseSymbol, ...stock }) => ({
    ...stock,
    companyName: companyLogoAndName[stock.symbol]?.name ?? stock.companyName,
    url: companyLogoAndName[stock.symbol]?.url ?? stock.url,
  }));

  useEffect(() => {
    const missingSymbols = popularStocks
      .map(({ symbol }) => symbol)
      .filter(symbol => !companyLogoAndName[symbol]?.name);

    if (missingSymbols.length) {
      getCompanyLogoAndName(missingSymbols.join());
    }
  }, [companyLogoAndName, getCompanyLogoAndName, popularStocks]);

  useEffect(() => {
    if (isEmpty(popularStocks)) {
      return () => {
      };
    }

    const mappedSymbols: SymbolAndStockExchangeCode[] = popularStocks.map(
      item => ({ symbol: item.symbol, stockExchangeCode: StockExchangeCodeType.US_NASDAQ }), // TODO:HW-1165  Get the stock exchange code from the API response
    );

    chartSubscription(mappedSymbols,
      [GWMarketDataSummaryBucket.OneDay, GWMarketDataSummaryBucket.ThreeMonths]);

    return () => {
      chartSubscription(mappedSymbols,
        [GWMarketDataSummaryBucket.OneDay, GWMarketDataSummaryBucket.ThreeMonths],
        true);
    };
  }, [popularStocks]);// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <WatchListTable isLoading={popularStocks.length === 0} watchListStocks={filteredStocks} />
  );
};

const mapStateToProps = (state: RootState) => ({
  isGettingPopularStocks: isCallStatusPending(FundamentalCall.getPopularStocks, state.fundamental.statusByCall),
  companyLogoAndName: state.fundamental.companyLogoAndName,
  popularStocks: state.fundamental.popularStocks,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  getCompanyLogoAndName: (symbols: string) => dispatch(getLogoAndName(symbols)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PopularWatchList);
